import { render, staticRenderFns } from "./LoginTwoFactorAuth.vue?vue&type=template&id=271b706b&"
import script from "./LoginTwoFactorAuth.vue?vue&type=script&lang=js&"
export * from "./LoginTwoFactorAuth.vue?vue&type=script&lang=js&"
import style0 from "./LoginTwoFactorAuth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports